import React, { useCallback } from 'react';
import WizardStepLayout from '../WizardStepLayout';
import { WIZARD_ACTIONS } from '../constants';

const ERA_OPTIONS = [
  { value: '', label: 'Select an era' },
  { value: '1760', label: 'Pre-1770' },
  ...[...Array(26).keys()].map((i) => ({
    value: String(1770 + i * 10),
    label: `${1770 + i * 10}s`,
  })),
  { value: '2030', label: 'Vision' },
];

const DateStep = ({ state, dispatch, onNext, onBack }) => {
  const handleChange = useCallback(
    (e) => {
      dispatch({ type: WIZARD_ACTIONS.SET_YEAR, payload: e.target.value });
    },
    [dispatch],
  );

  const isValid = Boolean(state.year && String(state.year).trim());

  return (
    <WizardStepLayout
      stepNumber={2}
      onNext={onNext}
      onBack={onBack}
      nextDisabled={!isValid}
      showBack
    >
      <select
        className="wizard__input wizard__select"
        value={state.year}
        onChange={handleChange}
      >
        {ERA_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={opt.value === ''}>
            {opt.label}
          </option>
        ))}
      </select>
    </WizardStepLayout>
  );
};

export default React.memo(DateStep);
